<template>
  <nav class="flex items-center justify-between flex-wrap p-6 w-full">
    <div class="flex items-center flex-shrink-0">
      <letter-t class="logo stroke-current fill-current text-gray-500 hover:text-white stroke-50" @mouseover="logoHover=true" @mouseleave="logoHover=false"></letter-t>
        <transition name="slide-fade">
          <span v-if="logoHover" class="text-xs text-white md:text-base">TAE NOPPAKUN WONGSRINOPPAKUN</span>
        </transition>
    </div>

      <div class="text-xs md:text-sm">
        <a href="mailto:tae8838@gmail.com" target="_blank">
          <mail-logo class="mr-3 inline-block w-10 stroke-current fill-current text-gray-500 hover:text-white cursor-pointer" />
        </a>
        <a href="https://www.instagram.com/photaegrapher/" target="_blank">
          <instagram-logo class="mr-3 inline-block w-10 stroke-current fill-current text-gray-500 hover:text-white cursor-pointer" />
        </a>
        <a href="https://github.com/tae8838" target="_blank">
          <github-logo class="mr-3 inline-block w-10 stroke-current fill-current text-gray-500 hover:text-white cursor-pointer" />
        </a>
        <a href="https://www.linkedin.com/in/tae8838/" target="_blank">
          <linkedin-logo class="mr-3 inline-block w-10 stroke-current fill-current text-gray-500 hover:text-white cursor-pointer" />
        </a>
        <router-link class="radiating" to="/projectList">
          <folder-icon class="folder-icon flex inline-block w-8 stroke-current fill-current text-red-600 hover:text-red-700 cursor-pointer" />
        </router-link>
      </div>
  </nav>
</template>
<script>
  import LetterT from '../assets/t.svg'
  import MailLogo from '../assets/mail.svg'
  import GithubLogo from '../assets/gh.svg'
  import LinkedinLogo from '../assets/in.svg'
  import InstagramLogo from '../assets/ig.svg'
  import FolderIcon from '../assets/folder.svg'

  export default {
    components: {
      LetterT,
      MailLogo,
      GithubLogo,
      LinkedinLogo,
      InstagramLogo,
      FolderIcon
    },
    data () {
      return {
        logoHover: false
      }
    },
    methods: {
      toggleName () {
        this.logoHover = !this.logoHover
      }
    },
    mounted () {
      // this.logoHover = true
      let that = this
      setTimeout(function(){
        that.logoHover = true
      }, 1000)
      setTimeout(function(){
        that.logoHover = false
      }, 3000)
    }
  }
</script>
<style>
.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 1s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-10px);
  opacity: 0;
}
.logo {
  z-index: 20;
}

.radiating {
  float: right;
  width: 45px;
  height: 45px;
  color: #fff;
  text-align: center;
  border: solid 1px red;
  border-radius: 50%;
  animation: red-pulse 1s infinite;
}

.folder-icon {
  margin: 5px 7px;
}

@keyframes red-pulse
{
  0% {
    box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.4);
  }
  100% {
    box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
  }
}
</style>
